import { render, staticRenderFns } from "./SalaryBasis.vue?vue&type=template&id=cfa4d37a"
import script from "./SalaryBasis.vue?vue&type=script&lang=js"
export * from "./SalaryBasis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports